import axios from 'axios'
import store from 'store'
import { API_URL } from '../config'

axios.defaults.baseURL = `${API_URL}/school/${store.get('schoolCode')}`

axios.interceptors.request.use(
  (req) => {
    req.headers = {
      // Authorization: `Bearer ${store.get('refreshToken')}`,
      ...req.headers,
    }
    req.baseURL = `${API_URL}/school/${store.get('schoolCode')}`
    return req
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const callApi = async (endpoint, {
  method = 'get', body, params, headers,
}) => {
  const accessToken = store.get('accessToken')
    || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNhZGIwMWViMDhhNzRkZmU3MjE0YTg0YzMyZGE5MTM3NmRiMGRhNzdiNzcxMzMzYWQ5Y2ZlYzY5ODI2ODJmMTU1YjY1NzIwZTA3YjVhOGUxIn0.eyJhdWQiOiI1IiwianRpIjoiM2FkYjAxZWIwOGE3NGRmZTcyMTRhODRjMzJkYTkxMzc2ZGIwZGE3N2I3NzEzMzNhZDljZmVjNjk4MjY4MmYxNTViNjU3MjBlMDdiNWE4ZTEiLCJpYXQiOjE1NTEyNTQzODMsIm5iZiI6MTU1MTI1NDM4MywiZXhwIjoxNTgyNzkwMzgzLCJzdWIiOiIyMDI4Iiwic2NvcGVzIjpbXX0.jcaqJ6lCnHW-MsW-6Q3eUGwpTLoTVGAFBiJGwP5L9f4AjMMKdVy5tp4BgWcX2F8v_2AkrIPVnwD8HlPbfKzkDXZD5AjywGmtvP1q9B1_TWfW2Xvgn17IgWUUikCA3z7cv-gdpNfZtWwrrUfYMHVrTBEOeCc6TRJnTf3e_4TqaCLK_sG3wZxRbiuGLu3_5He27oL3Et5VN4y8bKKEwLUtK5eweSkn4F14oAKUgbr5-LQ_8uuiMs1JWXll7lCWvfWzi2SwoOijyGdLOuoa-3lGuCUFw53y6FQXZC5h1Aht_OrNQ8I0dDeuZyyUQjkl38SbuEfFS-ssVhh9jUkfW-k3ZrVAfPuYqzOLkfvhjUUz0CEaWG_KRSMLNSuwK2IKRmNyXz4qkdMuPwcJlA-VR3CfTK5TCevPHARu4iU66bnaAR0r8EbKdHlonejcnmO612OrcWN4JgdS1TT2iZOrXDBDfVUQh7a2a9FaySn78Bahzbg8DtLNY_57e6P_0nO3q3wrW0YJ7yIcMah8l7RcgpTwL9Z989-F-tZkKE0nGXnSZZclfjHHe0QBce6VebTFzxTmkMQ_Jw6KN6gA1dauOv-LVwC-i7QoTg2kFtaOovFNtZSV99S4jE35b3qR1onpHKM7Fz7izUonOhzHYHbrqcqntNY0ErytXIYSwd7E7gCdvY8.eyJhdWQiOiIzIiwianRpIjoiNTZmZWY3MjE1NTI4ZjhiYmVhODZlMTA5N2JmMWEwNjVkZmE1YzU0MjhjM2U2N2Y2YmZjMWZmZjczNTgwZDNmMGM2YWYyNjgyZjYxOTQyZWQiLCJpYXQiOjE1NDc3NzU1ODUsIm5iZiI6MTU0Nzc3NTU4NSwiZXhwIjoxNTc5MzExNTg1LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.aQxlv_aYMCstORc9fBIq0vTtXCqYttHCdAiNvuqiO4J0-jPmfKq6noCXOFWsEo3iUCdO2Aav0x4N6n7ahyll0sAa5whuU1DVSz6EJ0B0SOXeyz6tltshOk8MODUYfUfuiBtqNGHApa7rm4ZYIcWn1T72x0K0Wd5esCsQ61xE_juOgjcyev9JfbqSpsP-WRwFYAEvA2DVxb5Q8OHDr5dz6Iqo8EULSTcmiQQkuvBsAjFfzsHdn9-iM0xF3GKZ2f2UNrf1_dfRplzIOk4W42TyrTGqQIhgYx9vwFRUFNjfqB_CngwLK1MIqxQVi-nKB_G3yfhZ1MErsLzFpLmgtCxV5fSGkmvKyTKQzL9zA1qm9PlAG8gm74lKjwUSC2ahP_HEXXH_Xqdkp-Jdt2ZToULqSudCyC3esvJN4PK5fB87QuWRCLW37ZxOzJWmKTzR1j4MqQP1Lz8FykLkNMqYuI6-GRjqELmh-uLTQo8gUTf1YctqYflQ3UhjbIGz7bGuefR0eru9ews2NXX9Y3I6PSnkkCuVraig9JL0WcnGY7rle24SfqeXZFA2rp-yTlGIcQKt-lRR247JjLcseBEY7Ym8Vg-LNge5eK5r4oqw8V4X1Er-cw6qviyodihS0mjevd9HUzJNasWjnHFUeP6LM--HSU68OebToqvPE3M0CBOHcYQ'
  const userId = store.get('userId')
  const response = await axios({
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...headers,
    },
    withCredentials: true,
    method,
    params: {
      user_id: userId,
      ...params,
    },
    url: endpoint,
    data: body,
    validateStatus() {
      return true
    },
  })
  const json = response.data
  if (response.status !== 200) {
    return Promise.reject(new Error(response.data.error_messages.join('\n')))
  }

  return json
}

export default {}
